(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-nav-dock"] && !Shopify.designMode) return;
  try {
    (() => {
    const dock = document.querySelector('[data-mobile-nav-dock]');
    const viewport = window.visualViewport;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (!dock || !viewport || !isIOS) return;

    let frameId = 0;

    const updatePosition = () => {
      frameId = 0;

      const dockHeight = dock.getBoundingClientRect().height;
      const top = Math.max(0, viewport.offsetTop + viewport.height - dockHeight);

      dock.style.setProperty('--mobile-nav-dock-top', `${top}px`);
    };

    const schedulePositionUpdate = () => {
      if (frameId) return;

      frameId = requestAnimationFrame(updatePosition);
    };

    dock.classList.add('mobile-nav-dock--visual-viewport');
    updatePosition();
    viewport.addEventListener('resize', schedulePositionUpdate, { passive: true });
    viewport.addEventListener('scroll', schedulePositionUpdate, { passive: true });
    window.addEventListener('scroll', schedulePositionUpdate, { passive: true });
    window.addEventListener('resize', schedulePositionUpdate, { passive: true });
    window.addEventListener('orientationchange', schedulePositionUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(schedulePositionUpdate).observe(dock);
    }

  })();
  } catch(e) { console.error(e); }
})();

})();
